import AmlForm from './aml-form';

export default AmlForm;
